import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { FileText, Headphones, MessageCircle, ListChecks, ShieldCheck } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <FileText size={24} data-id="element-207" />,
    title: 'La Guía Maestra S.O.S. Berrinches',
    description: '(PDF de lectura rápida).'
  }, {
    icon: <ShieldCheck size={24} data-id="element-208" />,
    title: 'Protocolo de Emergencia',
    description: 'Qué hacer paso a paso en el supermercado o reuniones.'
  }, {
    icon: <Headphones size={24} data-id="element-209" />,
    title: 'Audio-Guía de Auxilio',
    description: 'Pon tu auricular y escucha mis instrucciones en tiempo real mientras ocurre la crisis.'
  }, {
    icon: <MessageCircle size={24} data-id="element-210" />,
    title: 'Scripts de Poder',
    description: 'Las frases exactas que desactivan la resistencia emocional.'
  }, {
    icon: <ListChecks size={24} data-id="element-211" />,
    title: 'Checklist de Detonantes',
    description: 'Identifica el hambre, sueño o sobreestimulación antes de la explosión.'
  }];
  return <section className="py-24 bg-white" data-id="element-212">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-213">
        <FadeIn data-id="element-214">
          <div className="text-center mb-16" data-id="element-215">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-216">
              Lo que incluye tu acceso hoy
            </h2>
            <p className="text-xl text-charcoal-light" data-id="element-217">
              Todo lo que necesitas para actuar con confianza.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-218">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === items.length - 1 ? 'md:col-span-2 md:max-w-md md:mx-auto w-full' : ''} data-id="element-219">
              <div className="flex items-start gap-4 p-6 rounded-2xl bg-cream border border-cream-dark hover:shadow-md transition-shadow h-full" data-id="element-220">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sage-100 text-sage-600 flex items-center justify-center" data-id="element-221">
                  {item.icon}
                </div>
                <div data-id="element-222">
                  <h3 className="text-lg font-bold text-charcoal mb-1" data-id="element-223">
                    {item.title}
                  </h3>
                  <p className="text-charcoal-light" data-id="element-224">{item.description}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}